export default __webpack_public_path__ + "static/media/table-action.72088a6b.svg";